// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a90c502e","900":"91eb9842"}[chunkId] + ".chunk.js";
};